module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 /*
"original_baseline"  - the approved budget
"value"              - the issue's total after this transaction
"diff_value"         - this specific transaction change
*/ ;
__p += '\n\n';
 if ( get("src") == "changeline" ) { ;
__p += '\n  ';
 var diff = get("source").getCodeChanges(budgetCode)*1000; ;
__p += '\n  ';
 var yeardiff = (get("value") - get("original_baseline"))*1000; ;
__p += '\n  ';
 var revised = get("value")*1000; ;
__p += '\n\n<div class="' +
((__t = ( changeClass(get("original_baseline"),get("value")) )) == null ? '' : __t) +
' trans-' +
((__t = ( changeClass(get("original_baseline"), get("original_baseline") + get("diff_value")) )) == null ? '' : __t) +
' ';
 if ( get('kind') == 'approved' ) { ;
__p += 'approved';
 } ;
__p += ' arrow arrow-bottom">\n\n  <!-- <div class="arrow"></div> -->\n  <div id="trans-tip" class="widget-popover fade in bottom arrow arrow-bottom tooltip-changeline">\n    <div class="widget-popover-title">\n        <h2 class="revised-diff ' +
((__t = ( changeClass(get("original_baseline"), get("original_baseline") + get("diff_value")) )) == null ? '' : __t) +
'">&lrm;' +
((__t = ( number_plus_minus(diff) )) == null ? '' : __t) +
' ₪' +
((__t = ( format_full_number( Math.abs(diff) ) )) == null ? '' : __t) +
'&rlm; </h2>\n        <div class="label-revised">סה״כ מעודכן</div>\n        <h2 class="revised">' +
((__t = ( format_full_number( revised ) )) == null ? '' : __t) +
'₪</h2>\n    </div>\n    <div class="widget-popover-content">\n      ';
 if ( yeardiff < 0 ) { ;
__p += '\n          <p class="tooltip-note">' +
((__t = ( (100 * (-yeardiff / (revised - yeardiff))).toFixed(1) + "%" )) == null ? '' : __t) +
'\n              קיצוץ מתחת לתקציב\n              ' +
((__t = ( get("source").get("year") )) == null ? '' : __t) +
'</p>\n      ';
 } ;
__p += '\n      ';
 if ( yeardiff > 0 ) { ;
__p += '\n          <p class="tooltip-note">' +
((__t = ( (100 * (yeardiff / (revised - yeardiff))).toFixed(1) + "%" )) == null ? '' : __t) +
'\n              תוספת מעבר לתקציב\n              ' +
((__t = ( get("source").get("year") )) == null ? '' : __t) +
'</p>\n      ';
 } ;
__p += '\n    </div>\n  ';
 } else { ;
__p += '\n      ';
 if ( get('kind') == 'approved' ) { ;
__p += '\n      <div id="trans-tip" class="widget-popover fade in bottom arrow arrow-bottom tooltip-approved">\n        <!-- <div class="arrow"></div> -->\n        <div class="widget-popover-title">\n          <h2 class="approved-sum">' +
((__t = ( format_full_number( get("value")*1000 ) )) == null ? '' : __t) +
'₪</h2>\n          <p> תקציב ' +
((__t = ( get("source").get("year") )) == null ? '' : __t) +
'\n              ';
 if ( get("continued") ) { ;
__p += '(המשכי)';
 } ;
__p += '\n              ';
 if ( get("proposed") ) { ;
__p += '(הצעה)';
 } ;
__p += '\n          </p>\n        </div>\n        <div class="widget-popover-content">\n            ';
 if ( !get('exact') ) { ;
__p += '\n                <b>משוערך</b> לפי הסעיפים הבאים:\n                <ul>\n                    ';
 var codes = get('source').get('orig_codes'); for ( var _i = 0 ; _i < codes.length ; _i++ ) { ;
__p += '\n                    <li>' +
((__t = ( codes[_i] )) == null ? '' : __t) +
'</li>\n                    ';
 } ;
__p += '\n                </ul>\n            ';
 } ;
__p += '\n        </div>\n      ';
 } else if ( get('kind') == 'used' ) { ;
__p += '\n      <div id="trans-tip" class="widget-popover fade in bottom arrow arrow-bottom tooltip-used ' +
((__t = ( changeClass(get("original_baseline"), get("original_baseline") + get("diff_value")) )) == null ? '' : __t) +
'">\n        <div class="widget-popover-title">\n            <h2 class="approved">' +
((__t = ( format_full_number( get("source").get('net_allocated')*1000 ) )) == null ? '' : __t) +
'₪</h2>\n            ';
 var diff = (get("source").get('net_revised') - get("source").get('net_allocated'))*1000; ;
__p += '\n            ';
 var revised = get("source").get('net_revised')*1000; ;
__p += '\n            <h2 class="revised-diff ' +
((__t = ( changeClass(get("original_baseline"), get("original_baseline") + get("diff_value")) )) == null ? '' : __t) +
'">&lrm;' +
((__t = ( number_plus_minus(diff) )) == null ? '' : __t) +
' ₪' +
((__t = ( format_full_number( Math.abs(diff) ) )) == null ? '' : __t) +
'&rlm; </h2>\n            <div>סה״כ מעודכן</div>\n            <h2 class="revised">' +
((__t = ( format_full_number( revised ) )) == null ? '' : __t) +
'₪</h2>\n                ';
 if ( diff < 0 ) { ;
__p += '\n                  <p class="tooltip-note">' +
((__t = ( (100 * (-diff / (revised - diff))).toFixed(1) + "%" )) == null ? '' : __t) +
'\n                      קיצוץ מתחת לתקציב\n                      ' +
((__t = ( get("source").get("year") )) == null ? '' : __t) +
'</p>\n                ';
 } ;
__p += '\n                ';
 if ( diff > 0 ) { ;
__p += '\n                  <p class="tooltip-note">' +
((__t = ( (100 * (diff / (revised - diff))).toFixed(1) + "%" )) == null ? '' : __t) +
'\n                      תוספת מעבר לתקציב\n                      ' +
((__t = ( get("source").get("year") )) == null ? '' : __t) +
'</p>\n                ';
 } ;
__p += '\n        </div>\n        <div class="widget-popover-content">\n            <h2 class="used">' +
((__t = ( format_full_number( Math.round( get("source").get('net_used')*1000 ) ) )) == null ? '' : __t) +
'₪</h2>\n            <p class="tooltip-note">(ההוצאה בפועל)</p>\n        </div>\n      ';
 } ;
__p += '\n  ';
 } ;
__p += '\n  </div>\n</div>\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/widget-change-tooltip.html
// module id = 148
// module chunks = 0